import React, { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import toast from 'react-hot-toast';
import FormModalLayout from '../Common/FormModalLayout';
import { processService } from '../../services/api';
import { userFacingError } from '../../i18n/userFacingError';
import { pickAnswerMediaTypeId, submitExigenciaAnswer } from '../../utils/exigenciaResposta';

function unwrap(payload) {
  return Array.isArray(payload) ? payload : payload?.data ?? payload?.items ?? [];
}

// Erro de validação local não tem `response`; o da API passa pelo filtro de mensagens seguras.
function answerErrorMessage(error) {
  return error?.response ? userFacingError(error, 'saveError') : error?.message || userFacingError(error, 'saveError');
}

/** Resposta do requerente a uma exigência: texto obrigatório e arquivo opcional (vai para os documentos do processo). */
const ExigenciaRespostaModal = ({ move, processoId, onClose, onAnswered }) => {
  const [texto, setTexto] = useState('');
  const [file, setFile] = useState(null);

  const { data: midiasRaw, isLoading: midiasLoading } = useQuery(['tipos-midia'], () =>
    processService.tipoMidiaCrud.getList({ limit: 200 })
  );
  const tipoId = pickAnswerMediaTypeId(unwrap(midiasRaw));
  const noMediaType = !midiasLoading && !tipoId;
  const fileDisabled = midiasLoading || noMediaType;

  const send = useMutation(
    () => submitExigenciaAnswer({ move, processoId, tipoId, texto, file }, processService),
    {
      onSuccess: () => {
        toast.success('Resposta da exigência enviada.');
        if (onAnswered) onAnswered();
        onClose();
      },
      onError: (e) => toast.error(answerErrorMessage(e)),
    }
  );

  return (
    <FormModalLayout
      title="Responder exigência"
      subtitle="A resposta fica vinculada à tramitação. O analista deferirá ou indeferirá."
      onClose={onClose}
      footer={
        <button
          type="button"
          className="btn btn-primary"
          disabled={texto.trim().length < 3 || send.isLoading}
          onClick={() => send.mutate()}
        >
          {send.isLoading ? 'Enviando…' : 'Enviar resposta'}
        </button>
      }
    >
      <p className="text-sm text-gray-700 whitespace-pre-wrap">{move.parecer || 'Exigência formal'}</p>
      <label htmlFor="exigencia-resposta-texto" className="form-label mt-3">
        Resposta
      </label>
      <textarea
        id="exigencia-resposta-texto"
        className="form-input"
        rows={5}
        value={texto}
        onChange={(e) => setTexto(e.target.value)}
      />
      <label htmlFor="exigencia-resposta-arquivo" className="form-label mt-3">
        Arquivo (opcional)
      </label>
      <input
        id="exigencia-resposta-arquivo"
        type="file"
        className="form-input"
        disabled={fileDisabled}
        onChange={(e) => setFile(e.target.files?.[0] || null)}
      />
      {noMediaType ? (
        <p className="mt-1 text-xs text-gray-500">
          O órgão ainda não tem tipo de mídia cadastrado. Para enviar arquivo, use Protocolar petição no Portal.
        </p>
      ) : (
        <p className="mt-1 text-xs text-gray-500">O arquivo entra nos documentos do processo junto com a resposta.</p>
      )}
    </FormModalLayout>
  );
};

export default ExigenciaRespostaModal;
